import CarbonCreditService from "@/_services/CarbonCreditService";

const state = {
    organizations: [],
    organizationSearch: '',
    organizationCountry: '',
    loading: false,
};

const mutations = {
    SET_ORGANIZATIONS(state, organizations) {
        state.organizations = organizations;
    },
    SET_SEARCH(state, search) {
        state.organizationSearch = search;
    },
    SET_COUNTRY(state, country) {
        state.organizationCountry = country;
    },
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
    UPDATE_ORGANIZATION(state, organization) {
        const index = state.organizations.findIndex(o => o.id === organization.id);
        if (index !== -1) {
            state.organizations.splice(index, 1, organization);
        }
    }
};

const actions = {
    async fetchOrganizations({ commit, state }, options = {}) {
        const force = options === true || options?.force === true;
        if (state.loading) return;
        if (!force && state.organizations.length > 0) return;

        commit('SET_LOADING', true);

        try {
            // Fetch all organizations (no search param); search is done client-side for speed
            const filters = {
                country: state.organizationCountry || undefined,
            };

            const res = await CarbonCreditService.searchOrganizations(filters);

            if (res.success) {
                const newOrgs = res.data.map(org => ({ ...org, expanded: false }));
                commit('SET_ORGANIZATIONS', newOrgs);
            }
        } finally {
            commit('SET_LOADING', false);
        }
    },
    setSearch({ commit }, search) {
        const normalizedSearch = search && search.trim() ? search.trim() : '';
        commit('SET_SEARCH', normalizedSearch);
    },
    setCountry({ commit, dispatch }, country) {
        commit('SET_COUNTRY', country);
        dispatch('fetchOrganizations', { force: true });
    },
    toggleOrgExpanded({ commit, state }, org) {
        const organization = state.organizations.find(o => o.id === org.id);
        if (organization) {
            commit('UPDATE_ORGANIZATION', { ...organization, expanded: !organization.expanded });
        }
    },
};

function matchSearch(text, q) {
    return (text || '').toLowerCase().includes(q);
}

const getters = {
    organizations: (state) => {
        const q = (state.organizationSearch || '').trim().toLowerCase();
        if (!q) return state.organizations;
        return state.organizations.filter((org) => {
            if (matchSearch(org.name, q) || matchSearch(org.address, q) || matchSearch(org.country, q) || matchSearch(org.website, q)) return true;
            if (org.subOrganizations && org.subOrganizations.some((s) => matchSearch(s.name, q) || matchSearch(s.address, q) || matchSearch(s.country, q) || matchSearch(s.website, q))) return true;
            return false;
        });
    },
    allOrganizations: (state) => state.organizations,
    loadingOrganizations: (state) => state.loading,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}; 